import StudentsList from "./StudentsList";
import React, { useEffect, useState } from "react";
import { search, srot } from "../../assets/images/images";
import "./StudentsList.css";
import DownlodeFile from "../downlodeFile/DownlodeFile";
import {
  fetchAllSchoolData,
  resetAllTeacherBySchool,
} from "../../state/actions/getAllTeacherBySchoolAction";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../features/auth/AuthContext";
import { useParams } from "react-router";
import PaginationView from "../../components/Pagination/PaginationView";
import SearchComponent from "../SearchComponent/SearchComponent";
import Helper from "../../utils/Helper";
import SortPopup from "../../pages/customSort/SortPopup";
import { addToHistory } from '../../state/reducers/historyReducer';
import { CircularProgress, Grid } from "@mui/material";
import { useRef } from "react";
import { useNavigate } from "react-router";
import DataTableListing from "../DataTableListing/DataTableListing";
import api from "../../api/api";
import { toast } from "react-toastify";
import search_bar from "../../assets/images/search.svg";
import BackButton from "../../components/BackButton/BackButton";
import AddProfilePopup from "../Add Profile/AddProfilePopup";
import defaultAvatar from "../../assets/images/student-profile-image.png";  
import EnrollmentResponsiveCards from "../../modules/admin/Dashboard/RecentEnrollment/EnrollmentResponsiveCards";

const Students = () => {
  const { token } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchOption, setsearchOption] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [grade, setgrade] = useState("");
  const [selectedMonth, setselectedMonth] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
 
   useEffect(() => {
     const handleResize = () => setIsMobile(window.innerWidth < 767);
     window.addEventListener("resize", handleResize);
     return () => window.removeEventListener("resize", handleResize);
   }, []);

  const dispatch = useDispatch();
  const itemsPerPage = 12;
 
  const {
    teachers,
    students,
    count,
    next,
    previous,
    totalPages,
    error,
    isLoading
  } = useSelector((state) => state.fetchSchoolData);
  const globalState = useSelector((state) => state.globalState);

  const navigate = useNavigate();
  const [statuses, setStatuses] = useState({});
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isVisiblefillter, setIsVisiblefillter] = useState(false);
  const sortRef = useRef(null);
  const filterRef = useRef(null);
  const [showAddPopup, setShowAddPopup] = useState(false);

  // ── Debounce search ──
useEffect(() => {
  const timer = setTimeout(() => setDebouncedSearch(searchOption), 400);
  return () => clearTimeout(timer);
}, [searchOption]);

useEffect(() => {
  setCurrentPage(1);
}, [debouncedSearch, sortOption, grade, selectedMonth]); 

// ── Outside click ──
useEffect(() => {
  const handleClickOutside = (e) => {
    if (sortRef.current && !sortRef.current.contains(e.target)) setIsVisible(false);
    if (filterRef.current && !filterRef.current.contains(e.target)) setIsVisiblefillter(false);
  };
  document.addEventListener("click", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  useEffect(() => {
    getAllteacherDetails();
    window.scrollTo(0, 0);
  }, [currentPage, debouncedSearch, sortOption, grade, selectedMonth]);

  useEffect(() => {
    return () => {
      dispatch(resetAllTeacherBySchool());
    };
  }, []); // Unconditionally called at the beginning

  useEffect(() => {
    dispatch(addToHistory('/dashboard/students'))
  }, [])

  const getAllteacherDetails = () => {
    const type = "Student"; // Define the type variable
    const school_id = globalState.school_id;
    dispatch(fetchAllSchoolData(currentPage, school_id, token, type, globalState.role, debouncedSearch, "", sortOption, grade, selectedMonth));
  };

  const handleSearch = (e) => {
    setsearchOption(e.target.value)
  }

  const handleSortOptionChange = (newSortOption) => {
    setSortOption(newSortOption);
  };

  const toggleStatus = async (student_id, currentStatus, user_id) => {
  setStatuses((prev) => ({
    ...prev,
    [student_id]: prev[student_id] !== undefined ? !prev[student_id] : !currentStatus,
  }));
  try {
    const result = await api.post(
      "super-admin/school/active-deactive/",
      { user_id, active: !currentStatus },
      { headers: { "Content-Type": "application/json", Authorization: `Token ${token}` } }
    );
    if (result.status === 200) {
      toast.success(!currentStatus ? "Student account has been enabled." : "Student account has been disabled.");
    } else {
      setStatuses((prev) => ({ ...prev, [student_id]: currentStatus }));
    }
  } catch (error) {
    setStatuses((prev) => ({ ...prev, [student_id]: currentStatus }));
  }
};

const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  const day = date.toLocaleString("en-GB", { day: "2-digit" });
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};
// const isSpecialAbility = students?.is_special_ability === true;

const columns = [
  {
    key: "student_profile_pic",
    title: "Student Name",
    render: (value, row) => (
      <div style={{ display: "flex", alignItems: "center", gap: 10 , position:"relative"}}>
        {value ? (
          <img src={value || defaultAvatar} alt={row.name} style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
        ) : (
          <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#e2e8f0", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: "#94a3b8", fontWeight: 600 }}>
            {row.name?.charAt(0)}
          </div>
        )}
        {row.is_special_ability && (
          <div className="sp-ability-dot" style={{
            position: "absolute",
            top: "19px",
            left: "22px",
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            background: "#fff",
            border: "2px solid #0068FF",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.15)",
            zIndex: 2
          }} />
        )}
        <span>{row.name}</span>
      </div>
    ),
  },
  { key: "student_id", title: "Student ID",  headerStyle: { textAlign: "center" },
      render: (v) => (
        <div style={{ textAlign: "center" }}>
          {v}
        </div>
      ),
  },
  { key: "grade",      title: "Grade",       headerStyle: { textAlign: "center" },
      render: (v) => (
        <div style={{ textAlign: "center" }}>
          {v}
        </div>
      ),
  },
  { key: "email",      title: "Email",        render: (v) => <span>{v}</span> },
  { key: "joined_at", title: "Joining Date", headerStyle: { textAlign: "center" },
      render: (v) => (
        <div style={{ textAlign: "center" }}>
          {formatDate(v)}
        </div>
      ),
  },
  {
    key: "active",
    title: "Status",
    headerStyle: { textAlign: "center" },
    render: (_, row) => {
      const isActive = statuses[row.student_id] ?? row.active;
      return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          onClick={() => toggleStatus(row.student_id, isActive, row.user_id)}
          style={{ width: 90, height: 30, borderRadius: 999, background: isActive ? "#E0F4FF" : "#f1f5f9", cursor: "pointer", position: "relative", display: "flex", alignItems: "center", transition: "background 0.25s", flexShrink: 0 }}
        >
          <span style={{ position: "absolute", left: isActive ? 12 : 30, fontSize: 12.5, fontWeight: 500, color: isActive ? "#0068FF" : "#94a3b8", transition: "left 0.25s", userSelect: "none" }}>
            {isActive ? "Active" : "Inactive"}
          </span>
          <div style={{ width: 22, height: 22, borderRadius: "50%", background: "#fff", position: "absolute", ...(isActive ? { right: 4 } : { left: 4 }), boxShadow: "0 1px 4px rgba(0,0,0,0.15)", transition: "all 0.25s" }} />
        </div>
        </div>
      );
    },
  },
  {
    key: "action",
    title: "Action",
    headerStyle: { textAlign: "center" },
    render: (_, row) => (
      <div style={{display: "flex", justifyContent:"center", alignItems:"center"}}>
      <span
        style={{ color: "#0068FF", fontSize: 13.5, fontWeight: 500, cursor: "pointer", textAlign:"center" }}
        onClick={(e) => { e.stopPropagation(); navigate(`/student/${row.student_id}`); }}
      >
        View Profile
      </span>
      </div>
    ),
  },
];
  return (
    <>
    {showAddPopup && (
        <AddProfilePopup
          entity="Student"
          toggleshowAddProfile={() => {
          setShowAddPopup(false);
          }}
        />
        )}    
      <BackButton handleClick={() => navigate("/dashboard/home")} buttonName="Back" />

    {/* Toolbar */}
    <div className="advisor-toolbar">
      <div className="advsior-left-tools">
        <h3>Students</h3>
        <SearchComponent
          search={search_bar}
          searchPlaceholder="Search Students"
          value={searchOption}
          onchange={handleSearch}
        />
        {/* <div className="search-bar">
          <img src={search_bar} alt="search-bar" />
          <div className="search-divider"></div>
          <input
            placeholder="Search Students"
            value={searchOption}
            onChange={(e) => setsearchOption(e.target.value)}
          />
        </div> */}
      </div>

      <div className="advisor-right-tools">
        {/* Grade Filter */}
        <div className="hidden md:!block" style={{ position: "relative" }} ref={filterRef}>
          <button className="sort-button"
            onClick={() => { setIsVisiblefillter((prev) => !prev); setIsVisible(false); }}
          >
            <i className="fa-solid fa-sliders" style={{ marginRight: 6 }}></i>
            Grade
          </button>
          {isVisiblefillter && (
            <div className="sort-menu" style={{ minWidth: 170 }}>
              <div style={{ padding: "8px 12px", fontSize: 12, fontWeight: 600, color: "#64748b" }}>Grade</div>
              <div className="sort-options"
                onClick={() => { setgrade(""); setIsVisiblefillter(false); }}
                style={{ color: !grade ? "#0068FF" : "#374151", fontWeight: !grade ? 600 : 400 }}
              >
                All Grades
              </div>
              {Object.keys(globalState.grade_details?.grade ?? {}).map((key) => (
                <div className="sort-options" key={key}
                  onClick={() => { setgrade(key); setIsVisiblefillter(false); }}
                  style={{
                    color: grade === key ? "#0068FF" : "#374151",
                    fontWeight: grade === key ? 600 : 400,
                    background: grade === key ? "#f0f7ff" : "#fff",
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                  onMouseLeave={(e) => e.currentTarget.style.background = grade === key ? "#f0f7ff" : "#fff"}
                >
                  {globalState.grade_details.grade[key]}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Sort */}
        <div className="hidden md:!block" style={{ position: "relative" }} ref={sortRef}>
          <button className="sort-button"
            onClick={() => { setIsVisible((prev) => !prev); setIsVisiblefillter(false); }}
          >
            <img src={srot} alt="sort" />
            Sort
          </button>
          {isVisible && (
            <div className="sort-menu">
              {[
                { label: "Name : A - Z", value: "A-Z" },
                { label: "Name : Z - A", value: "Z-A" },
                { label: "Newest First", value: "Newest" },
                { label: "Oldest First", value: "Oldest" },
              ].map((option) => (
                <div className="sort-options" key={option.value}
                  onClick={() => { setSortOption(option.value); setIsVisible(false); }}
                  style={{
                    color: sortOption === option.value ? "#0068FF" : "#374151",
                    fontWeight: sortOption === option.value ? 600 : 400,
                    background: sortOption === option.value ? "#f0f7ff" : "#fff",
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                  onMouseLeave={(e) => e.currentTarget.style.background = sortOption === option.value ? "#f0f7ff" : "#fff"}
                >
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div>

          <button className="add-advsior-button" onClick={() => setShowAddPopup(true)}>
                 + Add Student
            </button>
      </div>
    </div>

    {/* Mobile Layout */}
      {isMobile && (
        <div className="sm:hidden px-2 mt-3 space-y-2">
          <div className="flex items-center justify-between">
            {/* FILTER */}
            <div className="relative  " ref={filterRef}>
              <button
                onClick={() => {
                  setIsVisiblefillter((prev) => !prev);
                  setIsVisible(false);
                }}
                className="flex items-center gap-2 px-3 border-none py-2 bg-white rounded-lg text-sm"
              >
                <i className="fa-solid fa-sliders"></i>
                Grade
              </button>

              {isVisiblefillter && (
                <div className="absolute left-0 mt-2 w-36 max-h-48 overflow-y-auto bg-white border rounded-lg shadow-md z-50">
                  <div className="px-3 py-2 font-semibold text-sm text-gray-500">
                    Grade
                  </div>

                  <div
                    className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100"
                    onClick={() => {
                      setgrade("");
                      setIsVisiblefillter(false);
                    }}
                  >
                    All Grades
                  </div>

                  {Object.keys(globalState.grade_details?.grade ?? {}).map(
                    (key) => (
                      <div
                        key={key}
                        className={`px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                          grade === key ? "text-blue-600 font-semibold" : ""
                        }`}
                        onClick={() => {
                          setgrade(String(key));
                          setIsVisiblefillter(false);
                        }}
                      >
                        {globalState.grade_details.grade[key]}
                      </div>
                    ),
                  )}
                </div>
              )}
            </div>

            {/* SORT */}
            <div className="relative" ref={sortRef}>
              <button
                onClick={() => {
                  setIsVisible((prev) => !prev);
                  setIsVisiblefillter(false);
                }}
                className="flex items-center gap-2 px-3 py-2 border-none bg-white rounded-lg text-sm"
              >
                <img src={srot} alt="sort" className="w-4 h-4" />
                Sort
              </button>

              {isVisible && (
                <div className="absolute right-0 mt-2 w-36 bg-white border rounded-lg shadow-md z-50">
                  {[
                    { label: "Name : A - Z", value: "A-Z" },
                    { label: "Name : Z - A", value: "Z-A" },
                    { label: "Newest First", value: "Newest" },
                    { label: "Oldest First", value: "Oldest" },
                  ].map((option) => (
                    <div
                      key={option.value}
                      className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        setSortOption(option.value);
                        setIsVisible(false);
                      }}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div style={{ marginTop: 30 }}>
        {isMobile ? (
          <EnrollmentResponsiveCards
            data={
              students?.map((student) => ({
                id: student.student_id,
                name: student.name,
                profilePic: student.student_profile_pic,
                grade: student.grade,
                email: student.email,
                joinDate: formatDate(student.joined_at) || "—",
                is_active: student.active,
                user_id: student.user_id,
                is_special_ability: student.is_special_ability,
              })) || []
            }
            userType="student"
            statuses={statuses}
            onCardClick={(item) => navigate(`/student/${item.id}`)}
            onToggleStatus={(id, is_active, user_id) =>
              toggleStatus(id, is_active, user_id)
            }
             pagination={{
              currentPage,
              total: count ?? 0,
              pageSize: 12,
              onChange: (page) => setCurrentPage(page),
            }}
          />
        ) : (
      <DataTableListing
        columns={columns}
        dataSource={students ?? []}
        rowKey="student_id"
        pagination={
          {
            currentPage,
            total: count ?? 0,
            pageSize: 12,
            onChange: (page) => setCurrentPage(page),
          }
        }
        checkable={false}
        loading={isLoading}
        emptyText="No Students Found"
        bordered={false}
        size="default"
        rowHoverColor="#F7F7F7"
      />
        )}
    </div>
  
    </>
  );
};

export default Students;
